module.exports = __webpack_public_path__ + "img/martin.5a4663b1.png";